export default __webpack_public_path__ + "assets/c75faf11c1f2af8c1adacb8b66911241.webp";